import SettingsOutlinedIcon from '@mui/icons-material/Settings';
import React from 'react';

export const SettingsIcon = ({
	bgColor = '#E2E5EC',
	width = 24,
	height = 24,
	...props
}) => {
	return (
		<SettingsOutlinedIcon
			{...props}
			sx={{
				backgroundColor: bgColor,
				width,
				height,
				borderRadius: 2,
				p: 0.5,
				color: '#fff',
			}}
		/>
	);
};
